
import { Component, EventEmitter, Input, Output , OnInit, OnChanges} from '@angular/core';


@Component({
  selector: 'app-barchartdash',
  templateUrl: './barChartDash.component.html',
  styleUrls: ['./barChartDash.component.scss']
})


export class BarChartDashComponent implements OnInit, OnChanges {

    @Input() data: any;

    resultado: any = [];


    Colores: Array<String> = ['boxVerde', 'boxNaranja'];

    constructor(){

    }

    ngOnInit(){

    }

    ngOnChanges(change){
      console.log(change);
      let max = 0;
      let mes = 0;
      let fecha = 99999999999999;

      this.resultado = [];

      // console.log(this.data);

      this.data.forEach(element => {
        const _max = parseInt(element.Total, 0);
        const _fecha = parseInt(element.Fecha, 0);

        if (_max > max){
          max = _max;
        }

        if (_fecha < fecha){
          fecha = _fecha;
          mes = parseInt(element.Mes, 0);
        }

      });
      console.log(max)
      console.log(fecha)

      if (this.data.length === 0){
        return;
      }


      if (this.data.length < 6){
        for (let i = 0; i <= 7 - this.data.length; i++){
          mes--;
          if (mes < 1){
            mes = 12;
          }

          this.data.push({
            Mes: mes,
            Total: 0
          });
        }
      }

      let n = 0;

      this.data.forEach(element => {
        let _clase = this.Colores[n];
        if (!_clase){
          _clase = 'boxNeutro';
        }



        if (element.Mes){
          this.resultado.push({
            mes: 'MesRed' + parseInt(element.Mes, 0),
            nivel: max < 1 ? 0 : Math.floor(element.Total * 100 / max),
            clase: ['nivelBox', _clase ],
            total: element.Total
          });
        }

        n++;
      });
      console.log(this.resultado)
    }



}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/componentes/graficas/barChartDash/barChartDash.component.ts